import { regionMessages } from "../../helpers/messages";
import { validateWhiteSpace } from "../../helpers/GlobalFunctions";
import { RegularExpressions } from "../../helpers/constants";

/**
 * @description function for validate each input field
 * @param stateObj Current state object
 * @returns Object with error messages
 */
export const validateRegionFields = (stateObj, fields = ['region']) => {
    var { errors, editObj } = stateObj;
    var errorFlag = false;
    for (let i = 0; i < fields.length; i++) {
        const field = fields[i];
        const reWhiteSpace = new RegExp(/^\s+$/);
        if (!editObj[field] || reWhiteSpace.test(editObj[field]) === true) {
            errorFlag = true;
            errors[field] = regionMessages[field];
        }
    }

    return { errorFlag, errors };
}

/**
 * @description function for validate Alphanumeric
 * @param value Alphanumeric fields
 * @returns Object with error messages
 */
export const validateAlphanumeric = (value) => {
    if (validateWhiteSpace(value)) {
        return { errorFlag: true, error: regionMessages.whiteSpace }
    }
    
    var errorFlag = !RegularExpressions.alphanumeric.test(value);
    return { errorFlag: errorFlag ? true : false, error: errorFlag ? regionMessages.alphaNumericRegex : '' }
}

/**
 * @description function for validate Alphanumeric with new line
 * @param value Alphanumeric fields
 * @returns Object with error messages
 */
export const validateAlphanumericNewLine = (value) => {
    if (validateWhiteSpace(value)) {
        return { errorFlag: true, error: regionMessages.whiteSpace }
    }
    
    var errorFlag = !RegularExpressions.alphanumericNewLine.test(value);
    return { errorFlag: errorFlag ? true : false, error: errorFlag ? regionMessages.alphaNumericRegex : '' }
}

/**
 * @description function for validate Alphabetic
 * @param value Alphabetic fields
 * @returns Object with error messages
 */
export const validateAlphabetic = (value) => {
    if (validateWhiteSpace(value)) {
        return { errorFlag: true, error: regionMessages.whiteSpace }
    }
    
    var errorFlag = !RegularExpressions.alphabetWithSpace.test(value);
    return { errorFlag: errorFlag ? true : false, error: errorFlag ? regionMessages.regionNameRegex : '' }
}